import { render, staticRenderFns } from "./InputTextPassword.vue?vue&type=template&id=4226bda1"
import script from "./InputTextPassword.vue?vue&type=script&lang=ts"
export * from "./InputTextPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports